module.exports = __webpack_public_path__ + "static/media/undraw_treasure_of9i.7fcdaad1.svg";